module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "解题过程",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoSolutionList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "相关知识",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoKnowledgeList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "解题提示",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoHintList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "删除题目",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteProblem(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc08100e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/problemTable/problemTable.vue
// module id = 654
// module chunks = 2